import { twinFeedbackCreateInputSchema, twinFeedbackCreateResponseSchema } from "../twin-feedback.js";
import { defineOperation } from "./http.js";
export const TWIN_FEEDBACK_OPERATIONS = {
    createFeedback: defineOperation({
        operationId: "twin.feedback.create", method: "POST", path: "/api/twin/feedback",
        audience: "public", requiredScope: "twin.query", rateClass: "create", mcpTool: "twin_feedback",
        request: { body: twinFeedbackCreateInputSchema },
        response: { kind: "json", status: 201, schema: twinFeedbackCreateResponseSchema },
        sdk: { namespace: "twin", method: "createTwinFeedback" },
        openapi: {
            summary: "Submit Twin feedback",
            description: "Submit user-confirmed Twin feedback, optionally attached to an owned routed session query.",
            responseDescription: "Feedback acknowledgement", errors: [400, 401, 403, 404],
        },
    }),
};
